export default {
  stepPrepare: "Préparer le paiement",
  stepProcess: "Traiter le paiement",
  stepConfirm: "Confirmer la commande",
  preparing: "Préparation de l'environnement de paiement",
  confirmingPayment: "Confirmation du paiement",
  confirmingOrder: "Confirmation de la commande",
  possibleIssue: "Problème potentiel détecté",
  settingUp: "Configuration d'un paiement sécurisé…",
  waitingConfirmation: "Attente de la confirmation de la transaction…",
  updatingAccount: "Mise à jour des informations de votre compte…",
  paymentSuccessful: "Paiement réussi !",
  upgradeSuccess: "Votre plan a été mis à niveau avec succès.",
  continue: "Continuer",
  somethingWentWrong: "Une erreur s'est produite lors de votre paiement.",
  tryAgain: "Réessayer",
  paymentCancelled: "Paiement annulé",
  cancelledTransaction: "Vous avez fermé la fenêtre de paiement ou annulé la transaction.",
  timeoutMessage:
    "Un problème est peut-être survenu. Vous pouvez vérifier si vos avantages ont pris effet. Si vous avez besoin d'aide, veuillez contacter notre support à {supportEmail}.",
  secureEncrypted: "Vos coordonnées bancaires sont chiffrées de manière sécurisée",
  havingTrouble: "Vous rencontrez des difficultés ? Contactez {supportEmail}",
};
